import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { api, publicApi } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const token = params.get("token");
    const nav = useNavigate();
    const [pw, setPw] = useState("");
    const [pw2, setPw2] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!token) { toast.error("Missing reset token"); return; }
        if (pw.length < 6) { toast.error("Min 6 characters"); return; }
        if (pw !== pw2) { toast.error("Passwords don't match"); return; }
        setLoading(true);
        try {
            await publicApi.post("/auth/reset-password", { token, new_password: pw });
            toast.success("Password updated. Please sign in.");
            nav("/login");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Reset failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center p-6">
            <div className="max-w-md w-full" data-testid="reset-root">
                <Link to="/" className="flex items-center gap-2 mb-10">
                    <div className="w-7 h-7 bg-white text-black flex items-center justify-center font-display font-black text-sm">R</div>
                    <span className="font-display font-bold">RepurposeAI</span>
                </Link>
                <div className="font-mono-ui text-xs tracking-[0.25em] uppercase text-zinc-500 mb-2">// NEW PASSWORD</div>
                <h1 className="font-display font-black text-4xl tracking-tighter">Choose a new one.</h1>
                <form onSubmit={submit} className="mt-6 space-y-4">
                    <div>
                        <Label className="font-mono-ui text-[10px] tracking-[0.25em] uppercase text-zinc-500">New password</Label>
                        <Input data-testid="reset-pw-input" type="password" required value={pw} onChange={(e) => setPw(e.target.value)} className="mt-2 h-11 bg-transparent border-white/15 focus:border-white text-white" />
                    </div>
                    <div>
                        <Label className="font-mono-ui text-[10px] tracking-[0.25em] uppercase text-zinc-500">Confirm</Label>
                        <Input data-testid="reset-pw2-input" type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} className="mt-2 h-11 bg-transparent border-white/15 focus:border-white text-white" />
                    </div>
                    <Button data-testid="reset-submit-btn" type="submit" disabled={loading} className="w-full h-11 bg-white text-black hover:bg-zinc-200 font-semibold">
                        {loading ? "Updating…" : "Update password →"}
                    </Button>
                </form>
            </div>
        </div>
    );
}
